import { render } from "./Offers.vue?vue&type=template&id=887972ea"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"

import "./Offers.vue?vue&type=style&index=0&id=887972ea&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__